
//export const baseUrl = 'https://api.doctall.com/api/v1'
// export const baseUrl = 'https://stage-api.doctall.com/api/v1'
export const usernameKey = `_da_${process.env.REACT_APP_ENV}_812022`.toLowerCase();
export const passcodeKey = `_da_${process.env.REACT_APP_ENV}_812023`.toLowerCase();
export const tokenKey = `_da_${process.env.REACT_APP_ENV}_812024`.toLowerCase();

export const baseUrl = process.env.REACT_APP_API_URL
export const api = {
  login: baseUrl + '/user/auth/login',
  google_login: baseUrl + '/user/auth/google/login',
  fb_login: baseUrl + '/user/auth/facebook/login',
  register: baseUrl + '/user/auth/register',
  verify_token: baseUrl + '/user/auth/verify-token',
  availability: baseUrl + '/user/auth/availability',
  cities: baseUrl + '/uploadDoc/allcities',
  areas: baseUrl + '/uploadDoc/allarea',
  partners: baseUrl + '/metadata/partner/getpartner',
  mobile_exist: baseUrl + '/user/auth/mobileNumExist/',
  send_otp: baseUrl + '/sms/send-otp',
  verify_otp: baseUrl + '/sms/verify-otp',
  signup_verify_otp: baseUrl + '/sms/register/verify-otp',
  email_send_otp: baseUrl + '/sms/doctall/send-otp',
  email_verify_otp: baseUrl + '/sms/email/verify-otp',
  resetpassword: baseUrl + '/user/auth/reset-password',
  changepassword: baseUrl + '/user/auth/change-password',
  compareprice_get: baseUrl + '/labtest/diagnostic/compareprices',
  compareprice_post: baseUrl + `/order/diagnostic/addToCart`
}
